"use strict";

// adds " - SCORED, FOLDED" to sizeText
module.exports = function (accumulator, printJob, product, component) {
  var addition = '';

  if (component.place_card_style === 'Tented') {
    addition = ' - SCORED, FOLDED';
  }

  return accumulator + addition;
};